<a target="_blank" [href]="file.link" [attr.aria-label]="'Download ' + (file.name | translate)" rel="noopener noreferrer">
    <div class="border-solid border-b-2 px-[0.8rem] border-gray-100 sm:h-[5.6rem] max-sm:min-h-[7.4rem] cursor-pointer flex gap-[1.6rem] items-center">
        <dsr-icon name="download" size="2.4rem" color="black" aria-hidden="true" />
        <span class="dsr-typescale-body-medium-prominent">
            {{ file.name | translate}}
        </span>
    </div>
</a>